import React, {useEffect, useRef} from "react";
import {
  Card,
  FlexItem,
  FlexLayout,
  H2,
  RadioButton, Spinner,
  StackLayout,
  Text
} from "@salt-ds/core";
import {FormattedMessage, useIntl} from "react-intl";
import CardHeader from "../../components/common/card-header/CardHeader";
import Constants from "../../components/common/Constants";
import StepTracker from "../../components/common/StepTracker";
import '../CommonCard.css';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {useLocation, useNavigate} from "react-router";
import PageNavigationCustom from "../../components/common/page-navigation/PageNavigationCustom";
import {customerServiceLink} from '../../common/ApiUtils';

function FirstTimeLogInSetupRegisterComputer() {

  const [showNotification, setShowNotification] = React.useState(true);
  const [registerDevice, setRegisterDevice] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigation = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);

  const handlePageSubmit = async () => {
        if (registerDevice === null) {
            setShowError(true);
            setErrorMessage("Please select a registration option to continue.");
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setShowError(false);
        navigation('/firstTimeLogInSetupComplete', {state: {registerDevice, from:'/firstTimeLogInSetupRegisterComputer'}});
    }

  const intl = useIntl()
    useEffect(() => {
        document.title = intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.step2.page.title'});
        // Set focus to main element for screen reader announcement
        if (mainRef.current) {
          mainRef.current.focus();
        }

        const expectedPreviousPage = "/firstTimeLoginSetup";
        if (location.state?.from !== expectedPreviousPage) {
          navigation('/');
        }
    }, [intl, location, navigation]);

    const passwordExpiryDate = location.state?.passwordExpiryDate;
    const isPasswordExpiryDateReceived = passwordExpiryDate && passwordExpiryDate !== 'null' && passwordExpiryDate !== 'undefined';

  return (
    <main ref={mainRef} role="main" aria-label="First Time Log In Setup Register Computer" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        <FlexItem className={`error-wrapper ${(showError || showNotification) ? 'visible' : ''}`}>
          <div>
            {isLoading ? (
                <FlexItem className="spinner-wrapper">
                  <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
                </FlexItem>
            ) : showError ? (
                <CardAlert status="error" setShowNotification={setShowError}>
                  {errorMessage}
                </CardAlert>
            ) : showNotification ? (
                <CardAlert status="success" setShowNotification={setShowNotification}>
                  {
                    isPasswordExpiryDateReceived ?
                        Constants.firstTimeLoginSetupPasswordChangeSuccessMessageWithDate(passwordExpiryDate) :
                        Constants.firstTimeLoginSetupPasswordChangeSuccessMessageWithoutDate
                  }
                </CardAlert>
            ) : null}
          </div>
        </FlexItem>
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={3}>

                <CardHeader style={{maxWidth: '21rem'}} heading={Constants.firstTimeLogInSetupTitle}
                  subheading={Constants.firstTimeLogInSetupStep2Title} />

                <StepTracker label1={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step1'})} step1="completed"
                  label2={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step2'})} step2="active"
                  label3={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step3'})} step3="pending" />
                <FlexItem>
                  <Text>
                    {Constants.firstTimeLogInSetupStep2InstructionalText(customerServiceLink)}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <H2><FormattedMessage id="logon.ui.firstTimeLoginSetup.flow.reRegisterComputer" /></H2>
                </FlexItem>

                <FlexItem>
                  <Text>
                    {Constants.firstTimeLoginSetupStep2Option1Info}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <RadioButton checked={registerDevice === true} data-testid="register-device-radio"
                    onClick={() => setRegisterDevice(true)}  aria-label="Register my web browser"/> {Constants.firstTimeLoginSetupStep2Option1Text}<br /><br />
                </FlexItem>
                <FlexItem>
                  <Text>
                    {Constants.firstTimeLoginSetupStep2Option2Info}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <RadioButton checked={registerDevice === false} data-testid="do-not-register-device-radio"
                    onClick={() => setRegisterDevice(false)} aria-label="Do not register my web browser"/> {Constants.firstTimeLoginSetupStep2Option2Text}
                </FlexItem>

                <br />
                <PageNavigationCustom onSubmit={handlePageSubmit} />

              </StackLayout>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );

}

export default FirstTimeLogInSetupRegisterComputer;